/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const GradingCircledIcon = /*#__PURE__*/ createSvgIcon(
  'GradingCircledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <g clipPath={`url(#${id}_0)`}>
            <circle cx={10} cy={10} r={10} fill="#E8EEF7" />
            <path
              d="M12.844 13.906l1.469-1.469a.547.547 0 01.796 0 .547.547 0 010 .797l-1.87 1.87a.55.55 0 01-.398.177.523.523 0 01-.388-.172l-.812-.812a.52.52 0 01-.164-.399.577.577 0 01.18-.398.547.547 0 01.796 0l.39.406zM5.563 15.5a.546.546 0 01-.401-.16.54.54 0 01-.162-.4.55.55 0 01.162-.4.54.54 0 01.4-.165h4.125c.16 0 .293.054.401.16a.54.54 0 01.162.4.55.55 0 01-.162.4.54.54 0 01-.4.165H5.561zm0-2.344a.546.546 0 01-.401-.16.54.54 0 01-.162-.399.55.55 0 01.162-.402.54.54 0 01.4-.164h4.125c.16 0 .293.054.401.161a.54.54 0 01.162.399.55.55 0 01-.162.401.54.54 0 01-.4.164H5.561zm0-2.344a.546.546 0 01-.401-.16.54.54 0 01-.162-.399.55.55 0 01.162-.401.54.54 0 01.4-.165h9.375c.16 0 .293.054.401.161a.54.54 0 01.162.399.55.55 0 01-.162.401.54.54 0 01-.4.165H5.562zm0-2.343a.546.546 0 01-.401-.161A.54.54 0 015 7.91a.55.55 0 01.162-.402.54.54 0 01.4-.164h9.375c.16 0 .293.053.401.16a.54.54 0 01.162.399.55.55 0 01-.162.402.54.54 0 01-.4.164H5.562zm0-2.344a.546.546 0 01-.401-.16.54.54 0 01-.162-.4.55.55 0 01.162-.4.54.54 0 01.4-.165h9.375c.16 0 .293.054.401.16a.54.54 0 01.162.4.55.55 0 01-.162.4.54.54 0 01-.4.165H5.562z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id={`${id}_0`}>
              <path fill="#fff" d="M0 0h20v20H0z" />
            </clipPath>
          </defs>
        </>
      ),
    },
  },
  false
);

export default GradingCircledIcon;
